export default __webpack_public_path__ + "static/media/based_swap.0c34f862.svg";